export enum PackageDealType {
  FLIGHT_HOTEL = "Flight_Hotel",
  CAR_HOTEL = "Car_Hotel",
}
